import { storeToRefs } from 'pinia'
import { usePlatformStore } from '@/store-pinia/platform'
import { PlatformSource } from '@/view-models/platform'
import { PaymentCurrency } from '@/view-models/currency'

type UseAfteeCampaignPromoHintOptions = {
  isPureBooking?: MaybeRefOrGetter<boolean>
  currencyCode?: MaybeRefOrGetter<string | null | undefined>
}

export function useAfteeCampaignPromoHint(_options: UseAfteeCampaignPromoHintOptions = {}) {
  const options = computed(() => unref(_options))
  const i18n = useI18n()
  const { $dayjs } = useNuxtApp()
  const platformStore = usePlatformStore()
  const { name: platformName } = storeToRefs(platformStore)

  const startAtIso = computed(() => (i18n.t('campaign_aftee_start_at') || '').trim())
  const endAtIso = computed(() => (i18n.t('campaign_aftee_start_end') || '').trim())

  const isCampaignInPeriod = computed(() => {
    const startAt = $dayjs(startAtIso.value)
    const endAt = $dayjs(endAtIso.value)
    if (!startAt.isValid() || !endAt.isValid()) {
      return false
    }

    const now = $dayjs()
    return (now.isAfter(startAt) || now.isSame(startAt)) && (now.isBefore(endAt) || now.isSame(endAt))
  })

  const isFunNowPlatform = computed(() => platformName.value === PlatformSource.FunNow)
  const isPureBooking = computed(() => toValue(options.value.isPureBooking ?? false))

  const isTwdCurrency = computed(() => {
    const code = toValue(options.value.currencyCode ?? '')
    return code?.toUpperCase() === PaymentCurrency.TWD
  })

  const shouldShowAfteePromoHint = computed(() => isFunNowPlatform.value && isTwdCurrency.value && !isPureBooking.value && isCampaignInPeriod.value)

  return {
    shouldShowAfteePromoHint,
    isCampaignInPeriod,
    isTwdCurrency,
  }
}
